import type { MediaImage } from '@efdigital/ll-addon-data';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Store } from '@warp-drive/core';

import type MediaImagesService from '../../services/media-images';
import { ImageUploaderFileInput } from './image-uploader-file-input.gts';
import { ImageUploaderFileUpload } from './image-uploader-file-upload.gts';

interface Signature {
  Args: {
    onImageUploaded: (image: MediaImage) => void;
  };
}

export class ImageUploader extends Component<Signature> {
  @service declare store: Store;
  @service('media-images') declare mediaImages: MediaImagesService;

  @tracked selectedFile: File | null = null;
  @tracked uploadedImage: MediaImage | null = null;

  fileSelected = (file: File): void => {
    this.selectedFile = file;
  };

  get previewImageStyle() {
    return htmlSafe('max-height: 400px;');
  }

  <template>
    <div class="image-uploader">
      {{#if this.selectedFile}}
        <ImageUploaderFileUpload
          @selectedFile={{this.selectedFile}}
          @onUploadComplete={{@onImageUploaded}}
        />
      {{else}}
        <ImageUploaderFileInput @onFileSelected={{this.fileSelected}} />
      {{/if}}
    </div>
  </template>
}
